import React from 'react';
import { Email as EmailIcon } from '@mui/icons-material';
import { StyledListItem, StyledListItemIcon, StyledListItemText } from '../styles';
var CustomerListItemEmail = function (_a) {
    var email = _a.email;
    return (React.createElement(StyledListItem, null,
        React.createElement(StyledListItemIcon, null,
            React.createElement(EmailIcon, null)),
        React.createElement(StyledListItemText, { primary: email, secondary: !email ? 'Missing' : '' })));
};
export default CustomerListItemEmail;
//# sourceMappingURL=CustomerListItemEmail.js.map